var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "message-list--item-appointment-info-confirmed" },
    [
      _c(
        "div",
        { staticClass: "message-list--item-appointment-info-confirmed-type" },
        [_vm._v(_vm._s(_vm.data.type))]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "message-list--item-appointment-info-confirmed-date" },
        [_vm._v(_vm._s(_vm.date) + " Uhr")]
      ),
      _vm._v(" "),
      _vm.customer
        ? _c(
            "div",
            {
              staticClass: "message-list--item-appointment-info-confirmed-extra"
            },
            [
              _c("div", [
                _vm._v(
                  "Du findest den Termin ab sofort in deinem Kalender und kannst ihn dort auch bearbeiten."
                )
              ]),
              _vm._v(" "),
              _vm.data.linkEligible && _vm.hasLink
                ? [
                    _c(
                      "div",
                      { staticClass: "mt-2" },
                      [
                        _c("Button", {
                          attrs: {
                            text: "Zugangsdaten bearbeiten",
                            icon: "edit"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("editAccessLink")
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.phoneNumber
                ? _c("div", { staticClass: "mt-2" }, [
                    _vm._v("\n\t\t\tTelefonnummer: "),
                    _c("a", { attrs: { href: "tel:" + _vm.phoneNumber } }, [
                      _vm._v(_vm._s(_vm.phoneNumberFormatted))
                    ])
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.applicant
        ? _c(
            "div",
            {
              staticClass: "message-list--item-appointment-info-confirmed-extra"
            },
            [
              _c("div", [
                _vm._v(
                  "Du findest den Termin ab sofort in deinem Kalender und kannst dort die Details einsehen."
                )
              ]),
              _vm._v(" "),
              _vm.data.linkEligible
                ? [
                    _vm.hasLink
                      ? _c("div", { staticClass: "mt-2" }, [
                          _c("div", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.message.appointment.accessLink,
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\tKlicke hier um den Link der Firma zu öffnen\n\t\t\t\t\t"
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.message.appointment.accessLinkUsername
                            ? _c("div", [
                                _vm._v(
                                  "\n\t\t\t\t\tBenutzername: " +
                                    _vm._s(
                                      _vm.message.appointment.accessLinkUsername
                                    ) +
                                    "\n\t\t\t\t"
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.message.appointment.accessLinkPassword
                            ? _c("div", [
                                _vm._v(
                                  "\n\t\t\t\t\tPasswort: " +
                                    _vm._s(
                                      _vm.message.appointment.accessLinkPassword
                                    ) +
                                    "\n\t\t\t\t"
                                )
                              ])
                            : _vm._e()
                        ])
                      : [
                          _vm._v(
                            "\n\t\t\t\tDie Zugangsdaten erhältst du rechtzeitig von der Firma.\n\t\t\t"
                          )
                        ]
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.message.appointment && _vm.message.appointment.phone
                ? _c("div", { staticClass: "mt-2" }, [
                    _vm._v(
                      "\n\t\t\tDu wirst angerufen unter der von dir hinterlegten Nummer " +
                        _vm._s(_vm.message.appointment.phone.formatted) +
                        ",\n\t\t\tdie wir deinem Gesprächspartner kurz vor dem Termin mitteilen.\n\t\t"
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }